<template>
  <div class="odwrap">
    <img
      :src="img"
      class="odimg"
      :class="{ hunodimg: hunbol }"
    />
    <div class="odmiddle">
      <div class="odmt twoline">{{ specName }}</div>
      <div class="odmb">冲印版数：{{ quantity }}</div>
    </div>
    <div class="odright omoney">
      <span class="f">{{ price | splitnum(0) }}</span
      >.{{ price | splitnum(1) }}
    </div>
  </div>
</template>
<script>
export default {
    name:'oditem',
    filters:{
        splitnum(val,index){
          return ((val/100).toFixed(2).split('.'))[index]
        }
    },
    props:{
      img:{
          type:String,
          default:'headImageUrl'
      },
      hunbol:{
          type:Boolean,
          default:false
      },
      specName:{
          type:String,
          default:''
      },
      quantity:{
          type:Number,
          default:1
      },
      price:{
          type:Number,
          default:0
      }
    }
};
</script>
<style lang="scss" scoped>
.odwrap {
  display: flex;
  .twoline {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .odimg {
    width: 52px;
    height: 74px;
    object-fit: contain;
    flex-shrink: 0;
    margin-right: 10px;
  }
  .hunodimg {
    width: 113px;
    height: 74px;
  }
  .odmiddle {
    flex-grow: 1;
    overflow: hidden;
    .odmt {
      font-size: 14px;
      color: #363636;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .odmb {
      font-size: 12px;
      color: rgba(54, 54, 54, 0.5);
    }
  }
  .odright {
    flex-shrink: 0;
    margin-left: 10px;
    font-size: 12px;
    color: #363636;
    align-self: flex-end;
    margin-bottom: 21px;
    &.omoney::before {
      display: inline-block;
      content: "￥";
      margin-right: 4px;
    }
    .f {
      font-weight: bold;
      font-size: 18px;
    }
  }
}
</style>